/* src/app/components/folder-actions-menu/folder-actions-menu.component.scss */
ion-icon {
  width: 18px;
  height: 18px;
}
.menu-item-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  border-radius: 15px;
  cursor: pointer;
}
.menu-item-container.delete-folder {
  color: var(--ion-color-danger);
}
.menu-item-container:hover {
  background: #f6f6f6;
}
.menu-item-container:hover.delete-folder {
  background: #ffe7e7;
  box-shadow: 0px 2px 8px 0px rgba(235, 68, 90, 0.4);
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #cbcbcb;
}
/*# sourceMappingURL=folder-actions-menu.component-HQXVHYW5.css.map */
